module.exports = __webpack_public_path__ + "74255506c6022d610723b9138836a761.svg";